module.exports = __webpack_public_path__ + "img/图2  阿尔塔米拉洞穴壁画.2c89ece4.jpg";